// auto-generated by bin/genVersion.ts
export const VERSION = '1.14.3';
//# sourceMappingURL=version.js.map